import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import {
  _setAttributes,
  addEventListenerImpl,
  appendChildImpl,
  appendRawHtmlImpl,
  createDocumentFragmentImpl,
  createElementImpl,
  createElementNSImpl,
  createTextNodeImpl,
  innerHTML,
  insertBeforeImpl,
  moveAllBetweenInclusiveImpl,
  parentNodeImpl,
  preventDefault,
  removeAllBetweenImpl,
  removeAttributesImpl,
  removeNode,
  setTextImpl
} from "./foreign.js";
const setText = setTextImpl;
const setAttributes = node => attrs => () => _setAttributes(node, attrs);
const removeAttributes = removeAttributesImpl;
const removeAllBetween = removeAllBetweenImpl;
const parentNode = /* #__PURE__ */ parentNodeImpl(Data$dMaybe.Just)(Data$dMaybe.Nothing);
const moveAllBetweenInclusive = moveAllBetweenInclusiveImpl;
const insertBefore = insertBeforeImpl;
const createTextNode = createTextNodeImpl;
const createElementNS = v => {
  if (v.tag === "Just") { return createElementNSImpl(v._1); }
  if (v.tag === "Nothing") { return createElementImpl; }
  $runtime.fail();
};
const createElement = createElementImpl;
const createDocumentFragment = createDocumentFragmentImpl;
const appendRawHtml = appendRawHtmlImpl;
const appendChild = appendChildImpl;
const addEventListener = addEventListenerImpl;
export {
  addEventListener,
  appendChild,
  appendRawHtml,
  createDocumentFragment,
  createElement,
  createElementNS,
  createTextNode,
  insertBefore,
  moveAllBetweenInclusive,
  parentNode,
  removeAllBetween,
  removeAttributes,
  setAttributes,
  setText
};
export * from "./foreign.js";
